










import Vue from 'vue'

export default Vue.extend({
  name: 'Disabled',
  computed: {
    anchorCancer (): string {
      return require('@/UI/Assets/anchor_cancer_bg.png')
    },
    anchorLine (): string {
      return require('@/UI/Assets/cancer_anchor_line_bg.png')
    }
  }
})
